module.exports = __webpack_public_path__ + "static/img/5.aeb4b28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/5.png
// module id = 79Ob
// module chunks = 0